import { connect } from 'react-redux';
import TinyReports from '../views/tiny/TinyReports';

function mapStateToProps(state, ownProps) {
  return {
    // 如果需要 Redux state，可以在這裡添加
  };
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  // 如果需要 Redux actions，可以在這裡添加
});

const TinyReportsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(TinyReports);

export default TinyReportsContainer;


